import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemFms} from '../FM/FormChooseFm.jsx'
import Model from './ModelSf.mjs'
import SfType from './SfType.jsx'

export const FormItemSfName = props => (
    <FormItemBizProp
        Model={Model}
        prop="sfName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemSfNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="sfNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemSfTypeCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="sfTypeCode"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={SfType}
        />
    </FormItemBizProp>
)

export default function FormChooseSf(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemFms />
            <FormItemSfNo />
            <FormItemSfName />
            <FormItemSfTypeCode />
        </FormChooseDesign>
    )
}
